// extracted by mini-css-extract-plugin
module.exports = {"information_icon":"heading_information_icon__2pQ5y","heading":"heading_heading__eI0gQ"};